import React from "react"
import ProductData from '../Utils/ProductData'
import clase from './ProductDetails.module.css';

const ProductDetails = (props) => {

    const colorOptions = props.data.colorOptions.map((item, pos) => {
        console.log();
        const classArr = [clase.ProductImage];
        
        if (pos === props.currentPreviewImage) {
            classArr.push(clase.SelectedProductImage);
            
        }
        return (

            <img key={pos} className={classArr.join(' ')} src={item.imageUrl} alt={item.styleName}
                onClick={() => props.onColorOptionClick(pos)} />


        );
    })

    const featureList = props.data.featureList.map((item, pos) => {
        const classArr = [clase.FeatureItem]
        
        if (pos === props.currentSelectedFeature) {
            classArr.push(clase.SelectedItem);
        }
       
        return (
            
            <button onClick={() => props.onFeatureItemClick(pos)} key={pos} className={classArr.join(' ')}> {item} </button>
        )
        
    })

    return (
        <div className={clase.ProductData} >
            <h1 className={clase.ProductTitle}>{props.data.title}</h1>
            <p className={clase.ProductDescription}>{props.data.description}</p>

            <h3 className={clase.sectionHeading}>Seleccionar Color</h3>

            {colorOptions}

            {/* <img className={[clase.ProductImage, clase.SelectedProductImage].join(' ') } src='https://imgur.com/iOeUBV7.png' alt='black watch' />
<img className={clase.ProductImage}  src='https://imgur.com/PTgQlim.png' alt='Red watch' />
<img className={clase.ProductImage} src='https://imgur.com/Mplj1YR.png' alt='blue watch' />
<img className={clase.ProductImage} src='https://imgur.com/xSIK4M8.png' alt='purple watch' /> */}


            <h3 className={clase.sectionHeading}>Caracteristicas</h3>
            <div className={clase.buttons}>

                <div> {featureList} </div>
                <button className={clase.PrimaryButton}>Comprar Ahora</button>

            </div>


        </div>


    );

}
export default ProductDetails;